export const KILLED = 'killed';
export const RETIRED = 'retired';
export const MOON = 'bought a moon';

export const endGameStatuses = [KILLED, RETIRED, MOON];

export type EndGameStatus = typeof endGameStatuses[number];
